import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

// Wrapper de /liftlogic/component-types (catálogo de tipos de componente).
// Sin estado: cada método retorna la data del axios.
//
// Los tipos de componente son GLOBALES (liftlogic super-tenant → sin scope por tenant).
const useComponentTypesApi = () => {
  const list = useCallback(async () => {
    const { data } = await axios.get(`${API_PATH}/liftlogic/component-types`, {
      headers: authHeaders(),
    });
    return data; // { types: [...] }
  }, []);

  const create = useCallback(async (payload) => {
    const { data } = await axios.post(`${API_PATH}/liftlogic/component-types`, payload, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  const update = useCallback(async (id, payload) => {
    const { data } = await axios.put(`${API_PATH}/liftlogic/component-types/${id}`, payload, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  const remove = useCallback(async (id) => {
    const { data } = await axios.delete(`${API_PATH}/liftlogic/component-types/${id}`, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  return useMemo(() => ({ list, create, update, remove }), [list, create, update, remove]);
};

export default useComponentTypesApi;
